(function () {
  var currentScript = document.currentScript;
  if (!currentScript || currentScript.dataset.tk9ProofStatsLoaded === 'true') return;
  currentScript.dataset.tk9ProofStatsLoaded = 'true';

  var config = {
    customerCount: parseCount(currentScript.getAttribute('data-customer-count')),
    customerEndpoint: currentScript.getAttribute('data-customer-endpoint') || '',
    reviewCount: parseCount(currentScript.getAttribute('data-review-count')) || 9161,
    reviewRating: currentScript.getAttribute('data-review-rating') || '4.9/5',
    socialLabel: currentScript.getAttribute('data-social-label') || '290K+ social followers',
    socialUrl: currentScript.getAttribute('data-social-url') || 'https://www.instagram.com/teamk9/',
    refreshMs: Math.max(15000, parseInt(currentScript.getAttribute('data-refresh-ms') || '60000', 10))
  };

  var formatter = new Intl.NumberFormat('en-US');
  var proofContainers = [
    '.tk9-blog-hub__trust',
    '.tk9-tips-proof-strip .wrap',
    '.bw-trust-row',
    '.bw-proof-strip',
    '[aria-label*="trust signal" i]',
    '[aria-label*="proof" i]'
  ];

  function parseCount(value) {
    var parsed = parseInt(String(value || '').replace(/[^\d]/g, ''), 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
  }

  function roundedCustomerLabel(count) {
    if (!count) return '';
    var rounded = Math.floor(count / 50000) * 50000;
    if (rounded < 1) return formatter.format(count) + ' verified buyers';
    return formatter.format(rounded) + '+ verified buyers';
  }

  function reviewLabel() {
    return formatter.format(config.reviewCount) + ' reviews';
  }

  function fullReviewLabel(includeRating) {
    return (includeRating ? config.reviewRating + ' ' : '') + reviewLabel();
  }

  function shouldSkipNode(node) {
    var parent = node.parentElement;
    if (!parent) return true;
    if (parent.closest('script,style,noscript,template,svg,head,[data-tk9-proof-stats-processed]')) return true;
    if (parent.closest('[aria-hidden="true"]')) return true;
    return false;
  }

  function replaceInTextNode(node) {
    if (shouldSkipNode(node)) return;
    var text = node.nodeValue || '';
    var next = text;
    var customer = roundedCustomerLabel(config.customerCount);

    if (customer) {
      next = next
        .replace(/\bJoin\s+(?:200,000\+|200k\+|250,000\+|250k\+|\d{1,3}(?:,\d{3})+\+?)\s+(?:happy\s+)?customers\b/gi, customer)
        .replace(/\bOver\s+(?:200,000\+|200k\+|250,000\+|250k\+|\d{1,3}(?:,\d{3})+\+?)\s+(?:Happy\s+)?Customers\b/g, customer)
        .replace(/\b(?:200,000\+|200k\+|250,000\+|250k\+|\d{1,3}(?:,\d{3})+\+?)\s+(Team K9\s+)?(?:happy\s+)?customers\b/gi, customer)
        .replace(/\b(?:200,000\+|200k\+|250,000\+|250k\+|\d{1,3}(?:,\d{3})+\+?)\s+(?:Team K9\s+)?dog parents\b/gi, customer);
    }

    next = next
      .replace(/\b9,000\+\s+store reviews\b/gi, reviewLabel())
      .replace(/\b9,000\+\s+reviews\b/gi, reviewLabel())
      .replace(/\b9,161\+\s+Reviews\b/g, reviewLabel())
      .replace(/\b4\.9\/5\s*\(\s*9,161\+?\s+Reviews\s*\)/gi, fullReviewLabel(true))
      .replace(/\b4\.9\/5\s*\(\s*9,000\+\s+Reviews\s*\)/gi, fullReviewLabel(true));

    if (next !== text) node.nodeValue = next;
  }

  function scanText() {
    if (!document.body) return;
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        return shouldSkipNode(node) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(replaceInTextNode);
  }

  function addSocialProof() {
    if (!document.body || !config.socialLabel) return;
    proofContainers.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (container) {
        if (container.dataset.tk9SocialProofAdded === 'true') return;
        var text = container.innerText || '';
        if (!/(review|customer|dog parent|guarantee|trust|proof)/i.test(text)) return;
        if (/social followers|Instagram|TikTok/i.test(text)) return;

        var span = document.createElement('span');
        span.className = 'tk9-proof-stat tk9-proof-stat--social';
        if (config.socialUrl) {
          var link = document.createElement('a');
          link.href = config.socialUrl;
          link.textContent = config.socialLabel;
          link.rel = 'noopener';
          span.appendChild(link);
        } else {
          span.textContent = config.socialLabel;
        }
        container.appendChild(span);
        container.dataset.tk9SocialProofAdded = 'true';
      });
    });
  }

  function injectStyle() {
    if (document.getElementById('tk9-proof-stats-style')) return;
    var style = document.createElement('style');
    style.id = 'tk9-proof-stats-style';
    style.textContent = [
      '.tk9-proof-stat a{color:inherit;text-decoration:none}',
      '.tk9-proof-stat a:hover{text-decoration:underline}'
    ].join('');
    document.head.appendChild(style);
  }

  async function refreshCustomerCount() {
    if (!config.customerEndpoint) return;
    try {
      var response = await fetch(config.customerEndpoint, {
        cache: 'no-store',
        credentials: 'omit',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) {
        if (response.status === 404 || response.status === 410) config.customerEndpoint = '';
        return;
      }
      var data = await response.json();
      var count = parseCount(data && (data.paidBuyerCount || data.customerCount || data.count || data.counts?.paidBuyers));
      var reviewCount = parseCount(data && (data.reviewCount || data.counts?.reviews));
      var socialLabel = data && (data.socialLabel || data.labels?.socialFollowers);
      if (reviewCount && reviewCount !== config.reviewCount) config.reviewCount = reviewCount;
      if (socialLabel && socialLabel !== config.socialLabel) config.socialLabel = String(socialLabel);
      if (count && count !== config.customerCount) {
        config.customerCount = count;
        scanText();
      }
      scanText();
      addSocialProof();
    } catch (error) {
      // Leave the verified static proof copy in place if the live endpoint is unavailable.
    }
  }

  function boot() {
    injectStyle();
    scanText();
    addSocialProof();
    observeLateProof();
    refreshCustomerCount();
    if (config.customerEndpoint) window.setInterval(refreshCustomerCount, config.refreshMs);
  }

  function observeLateProof() {
    if (!window.MutationObserver || !document.body) return;
    var timer = null;
    var observer = new MutationObserver(function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        scanText();
        addSocialProof();
      }, 150);
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    window.setTimeout(function () { observer.disconnect(); }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
